var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPencilEdit = function SvgPencilEdit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.49991C8.63132 1.36859 8.78722 1.26441 8.9588 1.19334C9.13038 1.12227 9.31428 1.08569 9.5 1.08569C9.68572 1.08569 9.86962 1.12227 10.0412 1.19334C10.2128 1.26441 10.3687 1.36859 10.5 1.49991C10.6313 1.63123 10.7355 1.78713 10.8066 1.95871C10.8776 2.13029 10.9142 2.31419 10.9142 2.49991C10.9142 2.68562 10.8776 2.86952 10.8066 3.0411C10.7355 3.21268 10.6313 3.36859 10.5 3.49991L3.75 10.2499L1 10.9999L1.75 8.24991L8.5 1.49991Z",
    stroke: "#6280DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPencilEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pencil-edit.0b46531c.svg";
export { ForwardRef as ReactComponent };